export const endpoints = {
  branding: () => '/dashboard/organizations/branding',
  getProviderUrl: () => '/dashboard/organizations/user/get-provider-urls',
  organizations: organizationCode => `/dashboard/organizations/${organizationCode}`,
  paymentMethods: () => '/dashboard/organizations/payment-methods',
  selectOrganization: organizationCode =>
    `/dashboard/auth/user/select-organization?organizationCode=${organizationCode}`,
  sendAuthEmail: () => '/dashboard/auth/user/local/signin',
  signInWithCode: () => '/dashboard/auth/user/local/verify',
  resendCode: () => '/dashboard/auth/user/local/resend',
  uploadLogo: () => '/dashboard/uploads/assets',
  user: () => '/dashboard/users/me',
  checkUserExistence: () => '/dashboard/auth/user/check-user-existence',
  verifySignUp: () => '/dashboard/auth/user/verify-signup',
  signUp: () => '/dashboard/auth/user/signup',
  getLoginUrl: merchantCode =>
    `/dashboard/auth/user/auth0/get-login-url?merchantCode=${merchantCode}`,
  createInvite: () => '/dashboard/invites',
  cancelInvite: () => '/dashboard/invites/cancel',
  resendInvite: () => '/dashboard/invites/resend',
  checkEmails: () => '/dashboard/invites/check-emails',
  organizationUsersCount: () => '/dashboard/organizations/users/counts',
  changePassword: () => '/dashboard/auth0/1800flowers/request-change-password-email',
  getInvite: () => '/public/invites',
  acceptInvite: () => '/public/invites/accept',
  removeOrganizationUsers: () => '/dashboard/organizations/users/remove',
  organizationUser: userCode => `/dashboard/organizations/users/${userCode}`,
  organizationUsers: () => '/dashboard/organizations/users',
  updateCompany: () => '/dashboard/organizations/company-profile'
};
